export function Card({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <section className={`rounded-card border border-line bg-surface p-4 shadow-card ${className}`}>{children}</section>;
}

export function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block space-y-1.5">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted">{label}</span>
      {children}
    </label>
  );
}

export const inputClass =
  'w-full rounded-card border border-line bg-surface px-3 py-2.5 text-sm text-ink outline-none transition-colors focus:border-brass';

export function PrimaryButton({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...props}
      className={`w-full rounded-card bg-navy px-4 py-3 text-sm font-semibold text-sand transition-opacity disabled:opacity-50 ${props.className ?? ''}`}
    >
      {children}
    </button>
  );
}
